import { render, staticRenderFns } from "./brandPartySetting.vue?vue&type=template&id=edfb1768"
import script from "./brandPartySetting.vue?vue&type=script&lang=js"
export * from "./brandPartySetting.vue?vue&type=script&lang=js"
import style0 from "./brandPartySetting.vue?vue&type=style&index=0&id=edfb1768&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports